module.exports = __webpack_public_path__ + "static/overlay-titles-dont-9fcb2ee67721cd312f9f8d00ceeaf4a0.png";